import { Component, HostListener } from '@angular/core';


@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  activeSection: string = 'inicio';
  private isScrolling: boolean = false;
  private scrollTimeout: any;

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      this.isScrolling = true;
      this.activeSection = sectionId;

      const navbar = document.querySelector('.navbar') as HTMLElement;
      const navbarHeight = navbar?.offsetHeight || 0;
      const targetPosition =
        element.getBoundingClientRect().top + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });

      this.closeMobileMenu();
    }
  }

  @HostListener('window:scroll')
  onScroll(): void {
    // Limpa o timeout anterior
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    // Aguarda o scroll estabilizar antes de reabilitar a detecção
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
    }, 150);

    // Não detecta automaticamente durante scroll programático
    if (this.isScrolling) {
      return;
    }

    const navbar = document.querySelector('.navbar') as HTMLElement;
    const navbarHeight = navbar?.offsetHeight || 0;
    const scrollPosition = window.scrollY + navbarHeight + 100;

    const sections = [
      'inicio',
      'weather-conditions',
      // 'mapa',
      'news',
      // 'cotacao',
      'about',
    ];

    // Itera de baixo para cima para garantir que a seção mais próxima seja detectada
    for (let i = sections.length - 1; i >= 0; i--) {
      const sectionId = sections[i];
      const element = document.getElementById(sectionId);
      if (element) {
        const sectionTop = element.offsetTop - navbarHeight - 50;

        if (scrollPosition >= sectionTop) {
          this.activeSection = sectionId;
          break;
        }
      }
    }
  }

  private closeMobileMenu(): void {
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarCollapse?.classList.contains('show')) {
      const toggleButton = document.querySelector(
        '.navbar-toggler',
      ) as HTMLElement;
      toggleButton?.click();
    }
  }
}
